import styled, { css } from 'styled-components';
import { hexToRgb } from '~/shared';
import openCaseItemBg from '../../assets/images/open_case_item_bg.svg';

const StyledDotsContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
	width: 240px;
	height: 240px;
	mask-image: url(${openCaseItemBg});
	mask-position: center;
	mask-repeat: no-repeat;
	-webkit-mask-image: url(${openCaseItemBg});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
`;

const StyledContainer = styled.div<{ $color: string }>((props) => {
	const color = hexToRgb(props.$color);

	return css`
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 240px;
		height: 240px;
		background: linear-gradient(
			180deg,
			rgba(${color.r}, ${color.g}, ${color.b}, 0) 0%,
			rgba(${color.r}, ${color.g}, ${color.b}, 0.5) 100%
		);
		border: 1px solid ${props.$color};
		border-radius: 40px;

		${StyledDotsContainer} {
			background-color: ${props.$color};
		}

		img {
			position: absolute;
			z-index: 2;
			width: 200px;
			height: auto;
			user-select: none;
			pointer-events: none;
		}

		.line {
			position: absolute;
			width: 120px;
			height: 10px;
			left: 50%;
			bottom: 30px;
			transform: translateX(-50%);
			background-color: ${props.$color};
			border-radius: 10px;
		}

		.item-enter {
			opacity: 0;
			transform: scale(0.9);
		}

		.item-enter-active {
			opacity: 1;
			transform: scale(1);
			transition:
				opacity 300ms,
				transform 300ms;
		}

		.item-exit {
			opacity: 1;
			transform: scale(1);
		}

		.item-exit-active {
			opacity: 0;
			transform: scale(0.9);
			transition:
				opacity 300ms,
				transform 300ms;
		}
	`;
});

export { StyledContainer, StyledDotsContainer };
